import { apiSlice } from "./apiSlice";

export const masterConfiguration = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getMasterData: builder.query({
            query: ({ module, category, ProjectId }) => ({
                 url: `Configuration/module/${module}/category/${category}${
                    ProjectId ? `?projectId=${ProjectId}` : ""
                }`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const { useGetMasterDataQuery } = masterConfiguration;